import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'Do I need an appointment or do you accept walk-ins?',
  answer: 'We recommend booking an appointment to guarantee availability and a seamless experience. However, we do accept walk-ins based on availability.'
}, {
  question: 'How long does a full session take?',
  answer: 'A full session of The Full Experience takes approximately 60-75 minutes. A standard cut takes between 30-45 minutes depending on the style.'
}, {
  question: 'What does The Full Experience include?',
  answer: "It includes a personalized consultation, precision cut, beard sculpting, hot towel treatment, wash, and final styling. It's our premium experience from start to finish."
}, {
  question: 'Do you work with all hair types?',
  answer: 'Absolutely. Our barbers are trained in all hair textures and types. Every cut begins with a personalized analysis to achieve the best result.'
}, {
  question: 'What payment methods do you accept?',
  answer: 'We accept cash, all major credit and debit cards, Apple Pay, Google Pay, and electronic transfers.'
}, {
  question: 'Do you offer services for special events?',
  answer: 'Yes, we offer packages for weddings, graduations, and corporate events. Contact us to design a custom package for your group.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 md:py-32 container mx-auto px-6 md:px-12" data-id="element-64">
      <motion.div className="text-center mb-16" initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} data-id="element-65">
        <h2 className="font-serif text-4xl md:text-5xl mb-6" data-id="element-66">
          Frequently Asked <span className="text-gold italic" data-id="element-67">Questions</span>
        </h2>
        <div className="w-24 h-[1px] bg-gold mx-auto" data-id="element-68"></div>
      </motion.div>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-69">
        {faqs.map((faq, index) => <motion.div key={index} className="glass-card rounded-sm overflow-hidden" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.08
      }} data-id="element-70">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-white/5 transition-colors" data-id="element-71">
              <span className="font-serif text-lg text-white/90 pr-4" data-id="element-72">
                {faq.question}
              </span>
              <motion.span animate={{
            rotate: openIndex === index ? 180 : 0
          }} transition={{
            duration: 0.3
          }} className="flex-shrink-0" data-id="element-73">
                <ChevronDownIcon className="w-5 h-5 text-gold" data-id="element-74" />
              </motion.span>
            </button>
            <AnimatePresence data-id="element-75">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} className="overflow-hidden" data-id="element-76">
                  <div className="px-6 pb-6 text-white/60 font-light leading-relaxed border-t border-white/5 pt-4" data-id="element-77">
                    {faq.answer}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>)}
      </div>
    </section>;
}